import request from '@/utils/request'
// 使用示例
export const getWithRetry = (url, params) => {
  return request({
    url,
    method: 'get',
    params,
    retry: true
  })
}
export const siteInfoApi = {
  
  getCompanyInfo() {
    return request({
      url: `/CompanyInfo`,
      method: 'get'
    })
  },getSiteInfo() {
    return request({
      url: `/SiteInfo`,
      method: 'get'
    })
  },getFaqs(params) {
    return request({
      url: `/Faq`,
      method: 'get',
      params
    })
  }
}
export const searchApi = {
  getResult(params) {
    return request({
      url: `/Statistic/query`,
      method: 'get',
      params
    })
  }
}


export const feedbackApi = {
  createFeedback(data) {
    return request({
      url: `/Feedback`,
      method: 'post',
      data
    })
  }
}


export const labelApi = {
  getLabels(params) {
    return request({
      url: `/LabelCategory`,
      method: 'get',
      params
    })
  }
}


export const bannerApi = {
  // 获取产品列表
  getBanners(params) {
    return request({
      url: '/Banner',
      method: 'get',
      params
    })
  },
}


export const serviceApi = {
  // 获取产品列表
  getServiceCoategories(params = null) {
    return request({
      url: '/ServiceCategory',
      method: 'get',
      params
    })
  },
}
/**
 * 产品相关接口
 */
export const productApi = {
  // getProductCategoryById(id) {
  //   return request({
  //     url: `/ProductCategory/${id}`,
  //     method: 'get'
  //   })
  // },

  // 获取产品分类
  getProductCategories(params = null) {
    //console.log("getProductCategories api ========= ",params)
    return request({
      url: '/ProductCategory',
      method: 'get',
      params,
      cache: true,
      cacheTime: 60000 // 可自定义缓存时间（10分钟）

    })
  },

  // 获取产品分类
  getProductCategoryTree(params = null) {
    return request({
      url: '/ProductCategory/tree',
      method: 'get',
      params,
      cache: true,
      cacheTime: 60000 // 可自定义缓存时间（10分钟）

    })
  },
  // 获取分类详情
  getProductCategoryById(id) {
    return request({
      url: `/ProductCategory/${id}`,
      method: 'get',
      cache: true,
      cacheTime: 60000 // 可自定义缓存时间（10分钟）

    })
  },

  // 获取产品列表
  getProducts(params) {
    return request({
      url: '/Product',
      method: 'get',
      params
    })
  },

  // 获取产品详情
  getHotProducts(viewcount) {
    return request({
      url: `/Product/viewcount/${viewcount}`,
      method: 'get'
    })
  },

  // 获取产品详情
  getProductDetail(id) {
    return request({
      url: `/Product/${id}`,
      method: 'get'
    })
  }
}

/**
 * 解决方案接口
 */
export const solutionApi = {
  // 获取列表
  getCategorys(params) {
    return request({
      url: '/SolutionCategory',
      method: 'get',
      params

    })
  },
  getSolutionCategoryById(id) {
    return request({
      url: `/SolutionCategory/${id}`,
      method: 'get'

    })
  },
  getSolutions(params) {
    return request({
      url: '/Solution',
      method: 'get',
      params

    })
  },

  // 获取详情
  getDetail(id) {
    return request({
      url: `/Solution/${id}`,
      method: 'get'
    })
  }
}

export const productusedApi= {
  // 获取列表
  getList(params) {
    return request({
      url: '/Productused/list',
      method: 'get',
      params
    })
  },
  // 获取详情
  getDetail(id) {
    return request({
      url: `/Productused/${id}`,
      method: 'get'
    })
  }
}
/**
 * 新闻资讯接口
 */
/**
 * 新闻资讯接口
 */
export const newsApi = {

  getCategory(params) {
    return request({
      url: '/newsCategory',
      method: 'get',
      params
    })
  },
  // 获取新闻列表
  getList(params) {
    return request({
      url: '/news',
      method: 'get',
      params
    })
  },

  // 获取新闻详情
  getDetail(id) {
    return request({
      url: `/news/${id}`,
      method: 'get'
    })
  }
}

/**
 * 其他公共接口
 */
export const commonApi = {
  // 获取轮播图
  getBanners() {
    return request({
      url: '/banners',
      method: 'get'
    })
  },

  // 获取公司信息
  getCompanyInfo() {
    return request({
      url: '/company/info',
      method: 'get'
    })
  }
}

// 统一导出
export default {
  productApi,
  newsApi,
  commonApi,
  serviceApi,
  productusedApi,
  solutionApi,
  siteInfoApi,
  feedbackApi,
  bannerApi
}